export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const UPDATE_GROUP_SUCCESS = "GET_GROUPS_SUCCESS";
export const ADD_GROUP_SUCCESS = "ADD_GROUP_SUCCESS";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const ACTIVATE_GROUP_SUCCESS = "ACTIVATE_GROUP_SUCCESSs";
export const IN_ACTIVATE_GROUP_SUCCESS = "IN_ACTIVATE_GROUP_SUCCESS";
